import { TextButton } from '@components/library/button/index';
import React, { FunctionComponent } from 'react';

interface EmbedAttachmentButtonProps {
  attachmentKey: string;
  displayUrl: string;
  name: string;
  url: string;
  downloadAttachment?: boolean;
}

const EmbedAttachmentButton: FunctionComponent<EmbedAttachmentButtonProps> = (props) => {
  const embedAttachment = (): void => {
    const { attachmentKey: key, displayUrl, downloadAttachment, name, url } = props;
    const attachmentEmbedInfo = {
      displayUrl,
      name,
      key,
      type: downloadAttachment ? 'download' : 'embed',
      url,
    };

    window.parent.postMessage(attachmentEmbedInfo, '*');
  };

  const { downloadAttachment } = props;

  return (
    <TextButton
      className={downloadAttachment ? "attach-attachment-button" : "embed-attachment-button"}
      icon={downloadAttachment ? "bff-download" : "bff-embed"}
      onClick={embedAttachment}
      size="small"
    >
      {downloadAttachment ? bfTranslate('Attach') : bfTranslate('Embed')}
    </TextButton>
  );
};

export default EmbedAttachmentButton;
